import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

interface StyledWrapperProps {
  maxWidth?: number;
  padding?: string;
}

const StyledWrapper = styled(ShowOn)<StyledWrapperProps>`
  max-width: ${({ maxWidth }) => maxWidth || '1568'}px;
  margin: auto;
  padding: ${({ padding }) => padding || '0px 40px'};
`;

interface DesktopWrapperProps extends StyledWrapperProps {}

export const DesktopWrapper: FC<PropsWithChildren<DesktopWrapperProps>> = ({
  children,
  maxWidth,
  padding,
}) => (
  <StyledWrapper
    screens={[Screen.Lg, Screen.Xl, Screen.Xxl]}
    maxWidth={maxWidth}
    padding={padding}
  >
    {children}
  </StyledWrapper>
);
